import { useEffect, useRef, useState } from "react"

// True once the element comes within `margin` of the viewport, and true from
// then on. A landing page uses it to hold back a big chunk (every guide's
// markdown) for a section below the fold that many visitors never reach.
export const useNearViewport = <T extends Element>(margin = "800px") => {
  const ref = useRef<T | null>(null)
  const [near, setNear] = useState(false)

  useEffect(() => {
    if (near) return
    const element = ref.current
    if (!element || typeof IntersectionObserver === "undefined") {
      setNear(true)
      return
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) setNear(true)
      },
      { rootMargin: margin }
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [near, margin])

  return [ref, near] as const
}
